import React from 'react';
import styled from "styled-components";

const Container = styled.input`
  padding: .5rem .7rem;
  border: 1px solid #d5d4d6;
  border-radius: 4px;
  outline: none;
  transition: .1s;
  &:hover {
    border-color: #b3b2b4;
  }

  &:focus {
    border-left: 3px solid #03a9f4;
  };
`;

const Input = ({...otherProps}) => {
    return (
        <Container {...otherProps}/>
    );
};

export default Input;
